import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface LoginPromptModalProps {
  visible: boolean;
  onClose: () => void;
  message?: string;
}

const LoginPromptModal: React.FC<LoginPromptModalProps> = ({ visible, onClose, message }) => {
  const navigate = useNavigate();

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-background rounded-2xl p-6 mx-8 max-w-sm w-full flex flex-col items-center gap-4 shadow-xl">
        <button
          onClick={onClose}
          className="self-end w-8 h-8 flex items-center justify-center rounded-full bg-muted"
        >
          <X className="w-4 h-4 text-muted-foreground" />
        </button>
        <div className="w-16 h-16 bg-secondary/10 rounded-full flex items-center justify-center">
          <LogIn className="w-7 h-7 text-secondary" />
        </div>
        <h3 className="text-lg font-semibold text-foreground">Login Required</h3>
        <p className="text-sm text-muted-foreground text-center">
          {message || 'Please login to access this feature.'}
        </p>
        <div className="flex gap-3 w-full">
          <Button
            onClick={() => { onClose(); navigate('/login'); }}
            className="flex-1 bg-secondary text-secondary-foreground hover:bg-secondary/90"
          >
            Login
          </Button>
          <Button
            variant="outline"
            onClick={() => { onClose(); navigate('/signup'); }}
            className="flex-1"
          >
            Sign Up
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LoginPromptModal;
